import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, flatten, mapMany, intersect, union } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiasPorClienteComp } from "./clientecomp";

interface Props {
    sugerencias: models.ContrareciboSugeridoModel[];
    /**Folios de las guias seleccionadas */
    guias: string[];
    onSeleccionar: (x: string[]) => void;
}

/**Obtiene las guias seleccionadas de un cliente*/
function getSeleccion(sugerencias: models.ContrareciboSugeridoModel[], guias: string[], idCliente: number): string[] {
    //Folios de las guias de ese cliente
    const gCliente =
        mapMany(sugerencias.filter(x => x.IdCliente == idCliente), x => x.Guias).map(x => x.Folio);

    return intersect(gCliente, guias);
}

/**Devuelve la nueva seleccion completa despues de haber sido cambiada la seleccion de un cliente */
function updateSeleccion(sugerencias: models.ContrareciboSugeridoModel[], todasGuias: string[], guiasCliente: string[], idCliente: number): string[] {
    //Folios seleccionados de los demas clientes
    const gOtrosClientes =
        intersect(
            mapMany(sugerencias.filter(x => x.IdCliente != idCliente), x => x.Guias).map(x => x.Folio),
            todasGuias
        );
    return union(gOtrosClientes, guiasCliente);
}

/**Componente que selecciona un conjunto de guias agrupadas por cliente */
export class MulticlienteSugerenciaComp extends React.PureComponent<Props> {
    onSeleccionar = (guiasCliente: string[], idCliente: number) => {
        const newSeleccion = updateSeleccion(this.props.sugerencias, this.props.guias, guiasCliente, idCliente);
        this.props.onSeleccionar(newSeleccion);
    }

    render() {
        return (
            <div>
                {
                    this.props.sugerencias.map(x =>
                        <GuiasPorClienteComp
                            guias={getSeleccion(this.props.sugerencias, this.props.guias, x.IdCliente)}
                            sugerencia={x}
                            onSeleccionar={guiasCliente => this.onSeleccionar(guiasCliente, x.IdCliente)}
                        />)
                }
                {
                    this.props.sugerencias.length == 0 &&
                    <div className="alert alert-info">
                        No hay guías
                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibos/multiclientecomp.tsx